export default __webpack_public_path__ + "static/media/logo3.dcddf236.png";